/**
 * Runtime resolution of the API base URL.
 *
 * In production the app is served on two subdomains that resolve to the
 * same Emergent deployment (`datacenter.universcosmetic.eu` and
 * `portal.universcosmetic.eu`). Because the FastAPI backend is reverse-
 * proxied on the SAME origin (Emergent's ingress routes `/api/*` to
 * port 8001), we simply hit the browser's own origin — which gives us:
 *   - Zero CORS overhead (same-origin requests)
 *   - Correct subdomain-scoped cookies (JWT, portal token)
 *   - No hardcoded preview URL bleeding into the built bundle
 *
 * For local development or the Emergent preview environment (where the
 * frontend is served from a different host than the API endpoint you
 * want to hit), we fall back to REACT_APP_BACKEND_URL from `.env`.
 */

const PROD_HOSTS = new Set([
    'datacenter.universcosmetic.eu',
    'portal.universcosmetic.eu',
]);

/** Return the API base URL (WITHOUT trailing slash, WITHOUT `/api`). */
export function getApiBase() {
    if (typeof window !== 'undefined' && window.location) {
        const host = window.location.hostname;
        if (PROD_HOSTS.has(host)) {
            return window.location.origin;
        }
    }
    return process.env.REACT_APP_BACKEND_URL || '';
}

export const API_BASE = `${getApiBase()}/api`;
